"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var Flex = function Flex(props) {
  var children = props.children,
      className = props.className,
      alignItems = props.alignItems,
      justifyContent = props.justifyContent,
      mobileFlex = props.mobileFlex,
      flexDirection = props.flexDirection;

  var getFlexResponsive = function getFlexResponsive() {
    return mobileFlex ? 'd-flex' : 'd-md-flex';
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(getFlexResponsive(), " ").concat(className, " ").concat(flexDirection ? 'flex-' + flexDirection : '', " ").concat(alignItems ? 'align-items-' + alignItems : '', " ").concat(justifyContent ? 'justify-content-' + justifyContent : '')
  }, children);
};

Flex.defaultProps = {
  mobileFlex: true,
  flexDirection: 'row',
  className: ''
};
var _default = Flex;
exports.default = _default;